import { render, staticRenderFns } from "./AttendanceClockRecord.vue?vue&type=template&id=56ab2255&scoped=true&"
import script from "./AttendanceClockRecord.vue?vue&type=script&lang=js&"
export * from "./AttendanceClockRecord.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceClockRecord.vue?vue&type=style&index=0&id=56ab2255&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab2255",
  null
  
)

export default component.exports